module.exports = __webpack_public_path__ + "img/28-image-1-1@2x.8c6cdcba.png";